import React from "react";
import { useNavigate } from "react-router";
import { useState, useEffect, useRef, useContext } from "react";
import "../../stylesheet/activities.css";
import TablePlaceholder from "../../Utils/TablePlaceholder";
import ToastContext from "../../context/toasterContex";
import {
  getAllInventory,
  deleteInventory,
  saveSelectedInventory,
} from "../../Utils/localStore";
import Topnav from "../others/Topnav";
import MoreActionButton from "../../components/patient/utils/MoreActionButton";

const InventoryReport = () => {
  const navigate = useNavigate();
  const { toast } = useContext(ToastContext);
  const [filter, setFilter] = useState("all");
  const [showDelete, setShowDelete] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [report, setReport] = useState(null);

  const handleChildAction = async (mode, details) => {
    if (mode === "view") {
      try {
        await saveSelectedInventory(details).then((resp) => {
          navigate("/inventory/new_inventory?mode=summary");
        });
      } catch (error) {
        console.log({ error });
      }
    } else if (mode === "edit") {
      try {
        await saveSelectedInventory(details).then((resp) => {
          navigate("/inventory/new_inventory?mode=edit");
        });
      } catch (error) {
        console.log({ error });
      }
    } else if (mode === "delete") {
      try {
        setShowDelete(true);
        setSelectedRecord(details);
      } catch (error) {
        console.log({ error });
      }
    }
  };

  const handleDeleteAction = async () => {
    try {
      const response = await deleteInventory(selectedRecord.localID).then(
        (resp) => {
          getLocalData();
          toast.success("Record deleted successfully", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      );
    } catch (error) {
      toast.error("Something went wrong, please try again later", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    setShowDelete(false);
  };

  const getLocalData = async () => {
    let response;
    try {
      await getAllInventory().then((resp) => (response = resp));
      return setReport(response);
    } catch (error) {
      toast.error(error, { position: toast.POSITION.TOP_CENTER });
      throw new Error(error);
    }
  };

  const filteredItems = report
    ?.filter((item) => {
      if (filter === "all") {
        return true;
      } else {
        return item.status === filter;
      }
    })
    .slice(0, 9);

  useEffect(() => {
    getLocalData();
  }, []);
  return (
    <>
      <Topnav />
        <div class="p-4 flex justify-between align-middle items-center">
          <div class="mt-4">
            <button onClick={() => 
          navigate("/inventory")
          }>
              <div class="flex items-center">
                <svg
                  stroke="currentColor"
                  fill="none"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="text-md"
                  height="30"
                  width="30"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>{" "}
                Back
              </div>
            </button>
          </div>
          <div>
          <button onClick={() => 
          navigate("/inventory/new_inventory")
          } class="bg-primary text-white font-bold p-3 rounded-full">
              Add New
            </button>
          </div>
        </div>
      <div className="report">
        {showDelete && (
          <dialog>
            <div className="w-[300px] bg-white rounded-md p-8 border">
              <p className="text-center mb-6">
                Are you sure you want to delete this record?
              </p>
              <div className="flex justify-between">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleDeleteAction();
                  }}
                  className="rounded-md text-white bg-primary p-2"
                >
                  Confirm
                </button>
                <button
                  autoFocus
                  className="p-2"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowDelete(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </dialog>
        )}
        <div className="report_header">
          <div className="button">
            <button
              className={filter === "all" ? "active" : ""}
              onClick={() => setFilter("all")}
            >
              All Invoices
            </button>
            <button
              className={filter === "Dispensed" ? "active" : ""}
              onClick={() => setFilter("Dispensed")}
            >
              Paid Income
            </button>
            <button
              className={filter === "Expired" ? "active" : ""}
              onClick={() => setFilter("Expired")}
            >
              Unpaid Invoices
            </button>
          </div>
          <button>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M3 7H21"
                stroke="#009FE3"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M6 12H18"
                stroke="#009FE3"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M10 17H14"
                stroke="#009FE3"
                strokeWidth="1.5"
                stroke-inecap="round"
              />
            </svg>
            Filter
          </button>
        </div>

        <div className="report_table">
          {report && report.length ? (
            <table>
              <thead>
                <tr>
                  <th className="tag_1">
                    <input type="checkbox" name="Prescription ID" id="pre_id" />{" "}
                    <span>INV ID</span>
                  </th>
                  <th>Product Name </th>
                  <th>Brand</th>
                  <th>Type</th>
                  <th className="status_head">
                    <span>Status</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {report.map((item, index) => (
                  <tr className={`${item.status}`} key={item.localID}>
                    <td>
                      {" "}
                      <span className="tag">
                        <input
                          type="checkbox"
                          name="Prescription ID"
                          id="pre_id"
                        />
                        {index + 1}
                      </span>
                    </td>
                    <td className="capitalize font-bold">{item.name || "-"}</td>
                    <td className="capitalize">{item?.brand || "-"}</td>
                    <td className="capitalize">{item.category || "-"}</td>
                    <td className="status">
                      <span>{item.status}</span>
                    </td>
                    <td className="capitalize">
                      <div className="text-center">
                        <MoreActionButton
                          onAction={handleChildAction}
                          details={item}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <TablePlaceholder lost="No Current Invoices" />
          )}
        </div>
      </div>
    </>
  );
};

export default InventoryReport;
